module.exports = __webpack_public_path__ + "assets/img/b6102ebeec0f2fa7e8f04bea2a225c14.png";